import { createMarkup } from "../../lib/helpers";
import React from "react";

interface XssSanitizedContentProps {
    content: string;
}

export default function XssSanitizedContent(props: XssSanitizedContentProps) {
    const safeContent = createMarkup(props.content);
    return <div dangerouslySetInnerHTML={{ __html: safeContent }} />;
}
